import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import debounce from "lodash.debounce";

import Media, { ScreenWidth } from "css/Media";

import WP from "WP";
import api from "api";
import modules from "modules";
import { setImageGallery, setCurrentView } from "store";

import Container from "partials/Container";
import GridElement from "partials/GridElement";
import Overlay from "partials/Overlay";
import ErrorBoundary from "partials/ErrorBoundary";
import Footer from "partials/Footer";
import Hero from "../../Accommodation/PageHero";

export class SingleActivityPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
    };
    this.debouncedCheckScreenSize = debounce(this.checkScreenSize.bind(this), 500);
  }

  componentDidMount() {
    this.checkScreenSize();
    this.props.setCurrentView(null);
    window.addEventListener("resize", this.debouncedCheckScreenSize);
    this.preparePage();
  }

  componentDidUpdate(nextProps) {
    if (nextProps.match.params.slug !== this.props.match.params.slug) {
      this.preparePage();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.debouncedCheckScreenSize);
  }

  preparePage() {
    window.scrollTo(0, 0);
    api.adventureFetcher
      .getBySlug({ slug: this.props.match.params.slug })
      .then((resp) => {
        const page = resp.data?.[0];
        this.props.setCurrentView(page);
        if (page) {
          this.setState({ activity: page }, () => this.scrapeForImages());
        }
      })
      .catch((error) => {
        console.error("Error fetching activity:", error);
      });
  }

  checkScreenSize() {
    const isMobile = ScreenWidth.lessThan("s");

    this.setState({ isMobile });
  }

  scrapeForImages() {
    if (!this.state.activity || !this.state.activity.acf) {
      return;
    }

    const activity = this.state.activity.acf;

    if (!activity.modules) {
      return;
    }

    const arr = [];
    arr.push({ image: activity.featured_image });

    const twoImagesArr = activity.modules.filter((module) => module.acf_fc_layout === "two_images");
    if (twoImagesArr.length) {
      twoImagesArr.forEach((module) => {
        arr.push({ image: module.image_one });
        arr.push({ image: module.image_two });
      });
    }

    const imageModuleArr = activity.modules.filter((module) => module.acf_fc_layout === "image");
    if (imageModuleArr.length) {
      imageModuleArr.forEach((module) => {
        arr.push({ image: module.image });
      });
    }

    this.props.setImageGallery(arr);
  }

  render() {
    const activity = this.state.activity;
    const { isMobile } = this.state;

    return activity ? (
      <Wrapper>
        <Hero item={activity} isMobile={isMobile} fixed={false} />
        <Container grid>
          <GridElement colStart={{ default: 1, s: 7, m: 4, l: 7 }} colEnd={{ default: 8, s: 18, m: 20, l: 18 }}>
            <StyledP>{activity.acf?.description}</StyledP>
          </GridElement>
        </Container>
        <Modules>
          <ErrorBoundary for="Activity Builder">
            {activity.acf &&
              activity.acf.modules &&
              activity.acf.modules.map((module, i) => {
                return (
                  <div key={i} className={"module-" + module.acf_fc_layout}>
                    {React.createElement(modules[module.acf_fc_layout], { data: module })}
                  </div>
                );
              })}
          </ErrorBoundary>
        </Modules>
        <Overlay />
        <ErrorBoundary for="Footer">
          <Footer />
        </ErrorBoundary>
      </Wrapper>
    ) : null;
  }
}

const mapStateToProps = (state) => {
  return {
    page: state.currentView,
    adventures: state.adventures.posts[WP.lang] ? state.adventures.posts[WP.lang] : [],
    availability: state.availability,
  };
};

const actions = {
  setImageGallery,
  setCurrentView,
};

export default connect(mapStateToProps, actions)(SingleActivityPage);

const Wrapper = styled.section`
  padding-top: 134px;

  ${Media.greaterThan("m")`
        padding-top: 132px;
    `}

  ${Media.greaterThan("l")`
        padding-top: 149.5px;
    `}
`;

const StyledP = styled.p`
  ${(props) => props.theme.fonts.h3}

  ${Media.greaterThan("s")`
        padding: ${(props) => props.theme.spacing.elementL} 0 ${(props) => props.theme.spacing.elementS};
    `}
`;

const Modules = styled.section`
  padding-bottom: ${(props) => props.theme.spacing.blockS};

  ${Media.greaterThan("s")`
        padding-bottom: ${(props) => props.theme.spacing.blockXL};
    `}
`;
